exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accounts-table {\n  background-color: white; }\n  .accounts-table svg:hover {\n    cursor: pointer; }\n", ""]);

// exports
